import { Container, Typography, CardMedia, Avatar, Skeleton, useMediaQuery } from '@mui/material';
import { PropTypes } from 'prop-types';

import 'react-responsive-carousel/lib/styles/carousel.min.css';
import '@fontsource/roboto/400.css';
import { createNewTheme } from '../../functions/utils';
import { ThemeProvider } from '@mui/material/styles';
import { useTheme } from '@emotion/react';


function Bloqueado({ onChange, changeConfigs, colorPrimary, colorSecondary, colorTertiary }, props) {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <ThemeProvider theme={createNewTheme(colorPrimary, colorSecondary, colorTertiary)}>

            <div style={{ top: 90, bottom: 0, right: 0, left: isMobile ? 0 : 80, position: "absolute" }}>
                <Typography style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", margin: "0" }}>
                    <Typography style={{ textAlign: "center", fontSize: "24px", color: "rgba(0,0,0,.3)", minWidth: "300px" }}>

                        <img alt="Bloqueado" src="https://gustio.com.br/imagens/noimage.jpg" style={{ width: 240 }} />

                        <div style={{ height: "10px" }}></div>
                            Desculpe, você não possui permissões para acessar essa página. Entre em contato com o administrador da conta para solicitar permissão.
                        <div style={{ height: "20px" }}></div>

                    </Typography>
                </Typography>
                <div style={{ height: "100px" }}></div>
            </div>

        </ThemeProvider>
    );
}

Bloqueado.propTypes = {
    windows: PropTypes.func,
};

export default Bloqueado;